import { render, staticRenderFns } from "./NewLandingPage2.vue?vue&type=template&id=563f9bac&scoped=true"
import script from "./NewLandingPage2.vue?vue&type=script&lang=js"
export * from "./NewLandingPage2.vue?vue&type=script&lang=js"
import style0 from "./NewLandingPage2.vue?vue&type=style&index=0&id=563f9bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f9bac",
  null
  
)

export default component.exports